import React from "react";
import { Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import HomePage2 from "./pages/HomePage2";
import Order from "./pages/Order";
import FlashScreen from "./pages/FlashScreen";
import ErrorPage from "../common/error/Component";
// import TableMenu from "./pages/TableMenu";  // for testing

function WebsiteRoute() {
  return (
    <Routes>
      <Route path="/" element={<FlashScreen/>} />
      <Route path="/table/qr" element={<HomePage/>} />
      {/* <Route path="/homepage" element={<HomePage/>} /> */}
      <Route path="/homepage2" element={<HomePage2/>} />
      <Route path="/orders" element={<Order/>} />
      <Route path="*" element={<ErrorPage/>} />
      {/* <Route path="/table/qr" element={<TableMenu />} /> */}
    </Routes>
  );
}

export default WebsiteRoute;
